import { Card, Link, Stack, Typography } from '@omnipresentgroup/design-system';

import { ReactComponent as PensionSchemeImg } from '../../../assets/duotone-pension-scheme.svg';

export const ContractorOnlyManagerPageNotAllowed = () => {
  const CONTACTMAIL = 'help@omnipresent.com';
  const handleOnContactClick = () => {
    window.open(`mailto: ${CONTACTMAIL}`);
  };
  return (
    <Card>
      <Stack p="64" align="center" gap="4">
        <PensionSchemeImg width={128} style={{ margin: 16 }} />
        <Typography as="h1" size="16" weight="medium" hideParagraphSpacing>
          This functionality is limited to Employees (EOR) only
        </Typography>
        <Typography as="h2" size="14">
          Please contact{' '}
          <Link size="16" onClick={handleOnContactClick}>
            {CONTACTMAIL}
          </Link>{' '}
          if you are looking to onboard EOR employees alongside your contractors
        </Typography>
      </Stack>
    </Card>
  );
};
